module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.textClass
  }, [_vm._t("label", function() {
    return [(_vm.hasLabel) ? _c('label', {
      staticClass: "rt-attr-label"
    }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]
  }), _vm._v(" "), _vm._t("default", function() {
    return [_c('span', {
      staticClass: "rt-attr-text"
    }, [_vm._v(_vm._s(_vm.text))])]
  }), _vm._v(" "), _vm._t("link", function() {
    return [(_vm.link) ? _c('div', {
      staticClass: "rt-attr-link"
    }, [_c('a', {
      on: {
        "click": _vm.link
      }
    }, [_vm._v(_vm._s(_vm.$tx('详情', 'xpc.business.attr.detail')))]), _vm._v(" "), _c('rt-icon', {
      attrs: {
        "name": "rt-base-arrow_right"
      }
    })], 1) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-398e5f1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/common/rtAttr.vue
// module id = 1491
// module chunks = 124